<template>
  <div>
    <label class="label">Resources</label>

    <div class="panel">
      <a
        class="panel-block resource-list-row"
        v-for="resource in resources"
        :key="resource.id"
        @click="resourceSelected(resource)"
        :class="{
          'has-background-grey-dark': isSelectedResource(resource),
          'has-text-light': isSelectedResource(resource)
        }"
      >
        <div class="title-block">{{ resource.name }}</div>
      </a>
    </div>
  </div>
</template>

<script>
import {
  GET_SELECTED_RESOURCE_ID,
  SELECT_RESOURCE_WITH_ID
} from '@/modules/resources/resourcesStore'

export default {
  name: 'ResourcesSidebar',
  components: {},

  props: {
    resourcesStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      resources: [
        {
          id: 'appIntro',
          name: 'App Intro',
          detailsRouterName: 'imageResourceDetails'
        }
      ]
    }
  },

  mounted() {
    if (this.$route.name === 'resourcesSidebar') {
      const selectResourceWithIdAction = `${this.resourcesStorePath}/${SELECT_RESOURCE_WITH_ID}`
      this.$store.dispatch(selectResourceWithIdAction, { adId: null })
    }
  },

  methods: {
    isSelectedResource(resource) {
      const getSelectedResourceId = `${this.resourcesStorePath}/${GET_SELECTED_RESOURCE_ID}`
      const selectedResourceId = this.$store.getters[getSelectedResourceId]

      return selectedResourceId === resource.id
    },

    resourceSelected(resource) {
      this.$router.push({
        name: resource.detailsRouterName,
        params: { resourceId: resource.id }
      })
    }
  },

  computed: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';

.resource-list-row {
  min-height: 41px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.panel {
  margin-bottom: 2px !important;
}

.panel-block {
  position: relative;

  .title-block {
  }
}
</style>
